<template>
  <div
    class="float"
    id="dangerbtn"
    ref="dangerbtn"
    :class="{ active: isActive, byleft: leftdir, byright: rightdir }"
    @touchstart.stop.prevent="touchstart"
    @touchmove.stop.prevent="touchmove"
    @touchend.stop.prevent="touchend"
  >
    <!--@click="single">-->
    <img src="../../assets/icons/dingdan.png" alt="" />
    <span>历史订单</span>
  </div>
</template>

<script>
export default {
  name: "float",
  data() {
    return {
      xstart: "",
      ystart: "",
      xmove: "",
      ymove: "",
      xend: "",
      yend: "",
      leftstart: "",
      topstart: "",
      isActive: false,
      leftdir: false,
      rightdir: false
    };
  },
  methods: {
    touchstart(e) {
      this.xstart = e.touches[0].pageX; // 起始点击位置
      this.ystart = e.touches[0].pageY; // 起始点击位置
      this.leftstart = this.$refs.dangerbtn.getBoundingClientRect().left; // 元素左边距
      this.topstart = this.$refs.dangerbtn.getBoundingClientRect().top; // 元素上边距
    },
    touchmove(e) {
      e.preventDefault(); // 取消事件的默认动作。
      this.xmove = e.touches[0].pageX; // 当前屏幕上所有触摸点的集合列表
      this.ymove = e.touches[0].pageY;
      let moveX =
        parseFloat(this.xmove) -
        parseFloat(this.xstart) +
        parseFloat(this.leftstart) +
        "px";
      let moveY =
        parseFloat(this.ymove) -
        parseFloat(this.ystart) +
        parseFloat(this.topstart) +
        "px";
      this.$refs.dangerbtn.style.left = moveX;
      this.$refs.dangerbtn.style.top = moveY;
      this.isActive = true;
    },
    touchend(e) {
      // let bodyW = window.innerWidth / 2 // 屏幕宽的一半
      let bodyH = window.innerHeight; // 屏幕高
      this.xend = e.changedTouches[0].pageX; // 松开位置
      this.yend = e.changedTouches[0].pageY; // 松开位置

      if (this.xstart === this.xend && this.ystart === this.yend) {
        // this.$emit("dangerclick");
        this.order();
      }

      let divW = this.$refs.dangerbtn.getBoundingClientRect().width; // 元素宽
      let divH = this.$refs.dangerbtn.getBoundingClientRect().height; // 元素高
      // 当最终位置在屏幕左半部分
      let leftX = window.innerWidth - parseFloat(divW);
      this.$refs.dangerbtn.style.left = leftX + "px";
      this.leftdir = false;
      this.rightdir = true;
      // 当元素顶部在屏幕外时
      if (parseFloat(this.$refs.dangerbtn.getBoundingClientRect().top) < 0) {
        // 置于顶部
        this.$refs.dangerbtn.style.top = "0px";
      }
      // 当元素底部在屏幕外时
      if (bodyH - this.yend < parseFloat(divH) / 2) {
        // 置于底部
        let topY = bodyH - parseFloat(divH);
        this.$refs.dangerbtn.style.top = topY + "px";
      }
      this.isActive = false;
    },
    order() {
      this.$router.push({
        name: "myOrder"
      });
    }
  }
};
</script>

<style lang="scss">
#dangerbtn {
  width: 2.773rem;
  height: 0.933rem;
  position: fixed;
  top: 12rem;
  right: 0;
  z-index: 92!important;
  background: -webkit-linear-gradient(
    45deg,
    #414987 0%,
    #732eaf 100%
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    45deg,
    #414987 0%,
    #732eaf 100%
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    45deg,
    #414987 0%,
    #732eaf 100%
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(45deg, #414987 0%, #732eaf 100%); /* 标准的语法 */
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#e74a4a, endColorstr=#5858b9);
  border-radius: .1rem 0 0 .1rem;
  text-align: center;
  padding: 0 0 0 6px;
  box-shadow: 0px 5px 10px rgba(18, 35, 108, 0.12);
  &.byright {
    border-radius: 0.1rem 0 0 0.1rem;
    padding: 0 0 0 6px;
  }
  &.active {
    /*-webkit-border-radius: 50%;*/
    /*-moz-border-radius: 50%;*/
    /*border-radius: 50%;*/
    border-radius: 0.1rem;
    padding: 0;
  }
  img {
    width: 0.307rem;
    height: 0.307rem;
    vertical-align: baseline;
    /*margin: 7px 0 3px;*/
  }
  span {
    display: inline-block;
    font-size: 0.4rem;
    color: #fff;
    height: 100%;
    line-height: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/float/float.vue